export const ormSelector = (state) => state.orm;
